var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
    'ph-button': true,
    ['ph-button--'+_vm.type]: true,
    ['ph-button--'+_vm.size]: true,
    'ph-button--full': _vm.isFull
  },attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }